import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function Testimonials() {
  const testimonials = [{
    quote: 'Antes dependíamos de Groupon para llenar la agenda. Ahora tenemos lista de espera para nuestros tratamientos premium. En 3 meses triplicamos nuestro ticket promedio.',
    name: 'Carolina M.',
    business: 'Luxe Skin Studio — Miami, FL',
    result: '+340% en citas premium'
  }, {
    quote: 'Doctor Ecommerce entendió nuestro negocio desde el día uno. Nos posicionaron como el spa de referencia en nuestra zona. Las clientas ahora nos buscan a nosotros, no al revés.',
    name: 'Patricia R.',
    business: 'Bella Vita Med Spa — Houston, TX',
    result: 'De 15 a 65 clientes semanales'
  }, {
    quote: 'Invertí en publicidad antes y perdí dinero. Con el sistema A.C.E. recuperé mi inversión en el primer mes y ahora genero $18K mensuales solo en tratamientos nuevos.',
    name: 'Diana L.',
    business: 'Glow Aesthetics — Tampa, FL',
    result: '$18K/mes en nuevos tratamientos'
  }];
  return <section className="py-20 md:py-28 px-4 bg-carbon relative border-t border-border" data-id="element-223">
      <div className="max-w-7xl mx-auto" data-id="element-224">
        <motion.div className="text-center mb-16 md:mb-24" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-225">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gold tracking-tight" data-id="element-226">
            Lo Que Dicen Nuestros Clientes
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-227">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="bg-surface border border-border rounded-2xl p-8 flex flex-col h-full shadow-xl hover:border-gold/30 transition-colors" data-id="element-228">
              <div className="flex gap-1 mb-6" data-id="element-229">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-230" />)}
              </div>

              <blockquote className="flex-grow mb-8" data-id="element-231">
                <p className="text-white text-lg italic leading-relaxed" data-id="element-232">
                  "{testimonial.quote}"
                </p>
              </blockquote>

              <div className="mt-auto pt-6 border-t border-border" data-id="element-233">
                <p className="font-bold text-gold text-lg mb-1" data-id="element-234">
                  {testimonial.name}
                </p>
                <p className="text-neutral-400 text-sm mb-4" data-id="element-235">
                  {testimonial.business}
                </p>
                <div className="inline-block bg-emerald/10 border border-emerald/20 text-emerald px-4 py-2 rounded-full text-sm font-bold" data-id="element-236">
                  {testimonial.result}
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}